import styles from "./StartupTeam.module.scss";
import { ModalOverlay } from "../ModalOverlay";
import { useState } from "react";
import { AddTeam } from "../AddTeam";

type StartupTeamProps = {
  team: Array<{ id: string; description: string }>;
  deleteTeamMember: Function;
};

export const StartupTeam = ({ team, deleteTeamMember }: StartupTeamProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={styles.wrapper}>
      <h3 className={styles.teamHeader}>TEAMLEDEN</h3>
      <h4 className={styles.teamDescription}>
        Bekijk hier jouw teamleden of voeg ze toe.
      </h4>
      <div className={styles.members}>
        {team.map(({ id, description }) => (
          <div className={styles.member} key={id}>
            <p className={styles.memberDescription}>{description}</p>
            <button
              className={styles.deleteMember}
              onClick={() => deleteTeamMember(id)}
            >
              <img src="/assets/ellipsis.svg" alt="ellipsis" />X
            </button>
          </div>
        ))}
      </div>
      <button className={styles.addMembers} onClick={toggleModal}>
        + Voeg teamlid toe
      </button>
      {isOpen && (
        <ModalOverlay show={isOpen}>
          <AddTeam show={isOpen} onToggle={toggleModal}/>
        </ModalOverlay>
      )}
    </div>
  );
};
